const Infrastructure =()=>
{
    return(
    <>
    <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">Campus Infrastructure</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    Infrastructure
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl infra-section">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3">Learning Infrastructure</h6>
                <h1 className="mb-5">Academic Facilities</h1>
            </div>
            
            <div className="row g-4">
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Smart Classrooms</h5>
                            <p className="card-text">Well-lit spacious class rooms with comfortable seating arrangements.</p>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Computer Lab</h5>
                            <p className="card-text">Well equipped computer lab with internet connection to meet the IT requirement s of the students.</p>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Central Library</h5>
                            <p className="card-text">Well stocked with reference books and text books as per Mysore University syllabus. Student has access to a wide range of contemporary books and journals to supplement the prescribed text books and reference books to empower their knowledge.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">English Lab</h5>
                            <p className="card-text">Audio Visual class room for the special coaching of English for the overall development of English Language and communication skills.</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl infra-section" style={{backgroundColor: "#f9f9f9"}}>
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-light text-center text-primary px-3">Student Life</h6>
                <h1 className="mb-5">Campus Facilities</h1>
            </div>
            
            <div className="row g-4">
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Cafeteria</h5>
                            <p className="card-text">Neat and tidy cafeteria located within the campus to meet the requirement of the students.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="card facility-card shadow">
                        <div className="card-body">
                            <h5 className="card-title">Hostel Facilities</h5>
                            <p className="card-text">Best hostel facilities are available at an affordable cost.</p>                          
                        </div>
                    </div>
                </div>
                {/* <div className="row g-5">
                <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                    <h3 className="mb-4">Student Hostels</h3>
                    <p>Our residential campus provides comfortable and secure accommodation for over 5,000 students. Separate hostels for boys and girls are designed to create a home away from home.</p>
                    
                    <div className="row mt-4">
                        <div className="col-6">
                            <h5><i className="fa fa-home text-primary me-2"></i>Hostel Amenities</h5>
                            <ul className="amenities-list">
                                <li><i className="fa fa-check"></i> 24/7 Security</li>
                                <li><i className="fa fa-check"></i> Wi-Fi Connectivity</li>
                                <li><i className="fa fa-check"></i> Laundry Services</li>
                                <li><i className="fa fa-check"></i> Common Rooms</li>
                                <li><i className="fa fa-check"></i> Study Areas</li>
                            </ul>
                        </div>
                        <div className="col-6">
                            <h5><i className="fa fa-utensils text-primary me-2"></i>Dining Facilities</h5>
                            <ul className="amenities-list">
                                <li><i className="fa fa-check"></i> Multiple Mess Halls</li>
                                <li><i className="fa fa-check"></i> Vegetarian & Non-veg</li>
                                <li><i className="fa fa-check"></i> Cafeteria & Food Court</li>
                                <li><i className="fa fa-check"></i> 24/7 Snack Bar</li>
                                <li><i className="fa fa-check"></i> Hygiene Certified</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="gallery-grid">
                        <div className="gallery-item">
                            <img src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Hostel Room"/>
                        </div>
                        <div className="gallery-item">
                            <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Dining Hall"/>
                        </div>
                        <div className="gallery-item">
                            <img src="https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Common Room"/>
                        </div>
                        <div className="gallery-item">
                            <img src="https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Hostel Exterior"/>
                        </div>
                    </div>
                </div>
            </div> */}
                
            </div>
        </div>
    </div>
    </>
    )
}
export default Infrastructure;